import type { JSX } from 'react';
import type { ReactNode } from 'react';
import { Button, Space, Typography } from 'antd';
import { LogoutOutlined, RobotOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';

import { authApi, type VkAppUser } from '../lib/authApi';

/** Шапка vk.brasol.ru: логотип, две вкладки, юзер + выход. */
export function Layout({
  user,
  children,
}: {
  user: VkAppUser;
  children: ReactNode;
}): JSX.Element {
  const location = useLocation();

  const navLink = (path: string, label: string) => {
    const active =
      path === '/' ? location.pathname === '/' || location.pathname.startsWith('/groups') : location.pathname.startsWith(path);
    return (
      <Link
        to={path}
        style={{
          padding: '6px 14px',
          borderRadius: 8,
          fontWeight: 600,
          fontSize: 14,
          color: active ? '#fff' : 'rgba(255,255,255,0.75)',
          background: active ? 'rgba(255,255,255,0.14)' : 'transparent',
        }}
      >
        {label}
      </Link>
    );
  };

  const fullName =
    [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email;

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f7' }}>
      <header
        style={{
          background: '#251D4A',
          color: '#fff',
          padding: '0 24px',
          height: 56,
          display: 'flex',
          alignItems: 'center',
          gap: 24,
        }}
      >
        <Space size={10} style={{ flexShrink: 0 }}>
          <RobotOutlined style={{ fontSize: 22, color: '#FF6900' }} />
          <Typography.Text strong style={{ color: '#fff', fontSize: 16 }}>
            ВК-бот БРАСОЛ
          </Typography.Text>
        </Space>
        <nav style={{ display: 'flex', gap: 6, flex: 1 }}>
          {navLink('/', 'Группы')}
          {navLink('/feed', 'Лента ответов')}
          {navLink('/training', 'Обучение')}
        </nav>
        <Space size={12}>
          <Typography.Text style={{ color: 'rgba(255,255,255,0.75)', fontSize: 13 }}>
            {fullName}
          </Typography.Text>
          <Button
            type="text"
            size="small"
            icon={<LogoutOutlined />}
            style={{ color: 'rgba(255,255,255,0.75)' }}
            onClick={async () => {
              await authApi.logout();
              window.location.reload();
            }}
          />
        </Space>
      </header>
      <main style={{ maxWidth: 1200, margin: '0 auto', padding: '24px 16px' }}>
        {children}
      </main>
    </div>
  );
}
